export default __webpack_public_path__ + "16768b14c329c5d0fb2a73394e5dd6cd.png";